// client/src/routes/app/rent/index.tsx — SCR-RENT-001 · RENT-003 (04 §8.5).
//
// Replaces UI-003's `PlaceholderScreen`, which was here so that its "all V1 module routes exist
// in the sidebar, may point to placeholder pages" criterion would be literally true, and which
// named this item as its owner. `/app/rent` is therefore no longer available to the moving
// „names its owning backlog item" assertion of PROP-004's deviation 369 — that test sits on
// `/app/contracts` today and must skip this route when CON-005 lands. See DEVIATIONS D-399.
//
// The route owns the URL state and nothing else: `validateSearch` runs the §9.2.3 schema, and
// the board reads it back typed. The navigated month is part of that state (§8.5), so a link to
// „the overdue rows of March" survives a refresh and browser Back steps the month back.
//
// The `Leasing.Read` guard is UI-003's and stays: the sidebar hides the entry, and this renders
// SCR-SYS-403 for the URL that was typed anyway (§9.2.2).

import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { RequirePermission } from '@/components/layout/route-guards';
import { ArrivalScope } from '@/components/motion/arrival';
import { RentScheduleBoard } from '@/features/rent/RentScheduleBoard';
import { rentSearchSchema, type RentSearch } from '@/features/rent/search';

export const Route = createFileRoute('/app/rent/')({
  validateSearch: rentSearchSchema,
  component: RentScreen,
});

function RentScreen() {
  const search = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });

  return (
    <RequirePermission permission="Leasing.Read">
      {/* One of the five hub screens (D-3741): the board arrives, once (D-3789). The same
          component on the property's tab has no scope of its own and stays still. */}
      <ArrivalScope arrive>
        <RentScheduleBoard
          search={search}
          onSearchChange={(next: (previous: RentSearch) => RentSearch) => {
            void navigate({ search: next });
          }}
        />
      </ArrivalScope>
    </RequirePermission>
  );
}
